module.exports = __webpack_public_path__ + "static/media/covidayuda_dinero.9e58e511.png";